"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickOnDidShareEvent = exports.clickOnWillShareEvent = exports.clickOnViewEvent = exports.clickOnLikeToggle = exports.setLikeStateWithTracking = exports.setLikeState = exports.setEvents = void 0;

var _api = require("./api");

var _actionTypes = require("./actionTypes");

var _constants = require("../../constants");

var trackViewEvent = function trackViewEvent(category) {
  return function (eventId) {
    return {
      type: _actionTypes.VIEW_EVENT,
      payload: {},
      meta: {
        analytics: {
          category: category,
          action: _constants.VIEW_EVENT_GA_ACTION,
          label: eventId
        }
      }
    };
  };
};

var trackWillShareEvent = function trackWillShareEvent(category) {
  return function () {
    return {
      type: _actionTypes.WILL_SHARE_EVENT,
      payload: {},
      meta: {
        analytics: {
          category: category,
          action: _constants.SHARE_ATTEMPT_GA_ACTION
        }
      }
    };
  };
};

var trackDidShareEvent = function trackDidShareEvent(category) {
  return function (shareType) {
    return {
      type: _actionTypes.DID_SHARE_EVENT,
      payload: {},
      meta: {
        analytics: {
          category: category,
          action: _constants.SHARE_GA_ACTION,
          label: _constants.SHARE_TYPE_GA_MAP[shareType]
        }
      }
    };
  };
};

var setEvents = function setEvents(data) {
  return {
    type: _actionTypes.SET_EVENTS,
    payload: data
  };
};

exports.setEvents = setEvents;

var setLikeState = function setLikeState(eventId, saveState) {
  return {
    type: _actionTypes.SET_EVENT_SAVED_STATE,
    payload: {
      eventId: eventId,
      saveState: saveState
    }
  };
};

exports.setLikeState = setLikeState;

var setLikeStateWithTracking = function setLikeStateWithTracking(eventId, saveState, category) {
  return {
    type: _actionTypes.SET_EVENT_SAVED_STATE,
    payload: {
      eventId: eventId,
      saveState: saveState
    },
    meta: {
      analytics: {
        category: category,
        action: saveState ? _constants.BOOKMARK_GA_ACTION : _constants.UNBOOKMARK_GA_ACTION
      }
    }
  };
};

exports.setLikeStateWithTracking = setLikeStateWithTracking;

var clickOnLikeToggle = function clickOnLikeToggle(category) {
  return function (eventId, shouldLike) {
    return function (dispatch) {
      var likeApiCall = _api.unsaveEvent;

      if (shouldLike) {
        likeApiCall = _api.saveEvent;
      }

      var action = setLikeStateWithTracking;

      if (!category) {
        action = setLikeState;
      }

      return likeApiCall(eventId).then(function () {
        return dispatch(action(eventId, shouldLike, category));
      });
    };
  };
};

exports.clickOnLikeToggle = clickOnLikeToggle;
var clickOnViewEvent = trackViewEvent;
exports.clickOnViewEvent = clickOnViewEvent;
var clickOnWillShareEvent = trackWillShareEvent;
exports.clickOnWillShareEvent = clickOnWillShareEvent;
var clickOnDidShareEvent = trackDidShareEvent;
exports.clickOnDidShareEvent = clickOnDidShareEvent;
//# sourceMappingURL=actions.js.map